import { splitAndTrimAll } from 'utils/string'
import { getObjectUtil } from 'packages/src'

/**
 * Converts an array of phrases into a string.
 * @param  {string} key
 * @param  {String[]|String} value
 * @returns {string}
 */
function arrayToStringFormatterUtil (key, value) {
  if (typeof value === 'string') {
    return value
  }
  return value.map(v => getObjectUtil(v, key)).join(', ')
}

/**
 * Converts string phrases separated by commas into an array of strings.
 * @param  {string} value
 * @returns {String[]}
 */
function stringToArrayFormatterUtil (value) {
  return splitAndTrimAll(value, ',')
}

/**
 * Converts a of string numbers separatad by commas to an array of numbers.
 * @param  {string} value
 * @returns {Number[]}
 */
function stringToArrayNumbersFormatterUtil (value) {
  return splitAndTrimAll(value, ',')
    .map(value => parseInt(value, 10))
}

/**
 * Converts the given string to a float.
 * @param  {string} value
 * @returns {Number|null}
 */
function toFloatFormatterUtil (value) {
  value = parseFloat(value)
  if (isNaN(value)) {
    value = null
  }
  return value
}

/**
 * Converts the given string to an integer.
 * @param  {string} value
 * @returns {Number|null}
 */
function toIntegerFormatterUtil (value) {
  value = parseInt(value, 10)
  if (isNaN(value)) {
    value = null
  }
  return value
}

/**
 * Converts the value into a date.
 * @param  {string} value
 * @returns {Number|null}
 */
function toDateFormatterUtil (value) {
  return value ? (new Date()).toISOString() : null
}

export {
  arrayToStringFormatterUtil,
  stringToArrayFormatterUtil,
  stringToArrayNumbersFormatterUtil,
  toFloatFormatterUtil,
  toIntegerFormatterUtil,
  toDateFormatterUtil
}
